import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=44cd3308&scoped=true"
import script from "./DataCard.vue?vue&type=script&lang=js"
export * from "./DataCard.vue?vue&type=script&lang=js"
import style0 from "./DataCard.vue?vue&type=style&index=0&id=44cd3308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd3308",
  null
  
)

export default component.exports